export default __webpack_public_path__ + "static/media/glitter-star.6891e7b8.png";